// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + (chunkId === 85 ? "lazy-app" : chunkId) + "." + {"46":"49e861ac45202320eefd","85":"7d173809308b60a75475"}[chunkId] + ".js";
};